import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from 'stores/ToastStore';
import { getSignedUrl, getSignedUrls } from 'utils/DocumentsAPIUtils';
/**
 * Hook that fetches a signed URL on demand and opens it in a new tab.
 *
 * @returns {{ fetchAndOpen: Function, loading: boolean }}
 */
export default function useSignedUrl() {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const fetchAndOpen = async ({ documentKey, foreignKey } = {}) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!documentKey && !foreignKey)
            return;
        const newWindow = window.open('', '_blank');
        setLoading(true);
        try {
            let url;
            if (documentKey) {
                const { data, errors } = await getSignedUrl(documentKey);
                if (((_a = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _a !== void 0 ? _a : 0) > 0) {
                    showToast(t('GET_SIGNED_URL_ERROR'), (_b = errors[0]) === null || _b === void 0 ? void 0 : _b.message, 'error');
                    newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                    return;
                }
                url = (_c = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _c === void 0 ? void 0 : _c.signedUrl;
            }
            else if (foreignKey) {
                const { data, errors } = await getSignedUrls([foreignKey]);
                if (((_d = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _d !== void 0 ? _d : 0) > 0) {
                    showToast(t('GET_SIGNED_URL_ERROR'), (_e = errors[0]) === null || _e === void 0 ? void 0 : _e.message, 'error');
                    newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                    return;
                }
                url = (_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.getSignedUrls) === null || _f === void 0 ? void 0 : _f.signedUrls) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.signedUrl;
            }
            if (url) {
                if (newWindow) {
                    newWindow.opener = null;
                    newWindow.location.href = url;
                }
            }
            else {
                newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                showToast(t('GET_SIGNED_URL_ERROR'), null, 'error');
            }
        }
        catch (e) {
            showToast(t('GET_SIGNED_URL_ERROR'), e.message, 'error');
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
        }
        finally {
            setLoading(false);
        }
    };
    return { fetchAndOpen, loading };
}
